import stylesheet from "./stylesheet";
import * as sentry from "../integrations/sentry";
import * as intercom from "../integrations/intercom";

export default history => {
  stylesheet();

  sentry.init();

  history.listen(() => {
    intercom.update();
  });
};



// WEBPACK FOOTER //
// ./src/core/bootstrap/index.js